import gql from 'graphql-tag'
import videoFields from './fragments/video-fields.gql'

export default () => gql`
  query getVideoDetailById($id: ID!) {
    video(id: $id, idType: DATABASE_ID) {
      ...videoFields
    }
  }
  ${videoFields}
`
